import type { FC } from 'react';
import classnames from 'classnames';

import { VideogameTreePlaceholder } from 'app/components/Placeholders';
import type { EventTreeValue } from 'app/pages/EventsPage/types';

import EventTree from './EventTree';
import CollapsedSelector from './CollapsedSelector';
import style from './style.scss';

interface Props {
  collapsed: boolean;
  loading: boolean;
  value: EventTreeValue;
  onChange: (values: EventTreeValue) => void;
}

const EventsSidebar: FC<Props> = ({ collapsed, loading, value, onChange }) => {
  const containerClassName = classnames(style.container, {
    [style.container_collapsed]: collapsed
  });

  if (loading) {
    return (
      <div className={containerClassName}>
        <VideogameTreePlaceholder />
      </div>
    );
  }

  return (
    <div className={containerClassName}>
      {collapsed ? (
        <CollapsedSelector value={value} onChange={onChange} />
      ) : (
        <EventTree value={value} onChange={onChange} />
      )}
    </div>
  );
};

EventsSidebar.displayName = 'EventsSidebar';

export default EventsSidebar;
